import type {Icebreaker as ImportedIcebreaker} from '@github-ui/copilot-chat/utils/copilot-chat-types'
import type {SafeHTMLString} from '@github-ui/safe-html'
import {useMemo} from 'react'

import data from './icebreakers.json'
import {SuggestionCard} from './SuggestionCard'
import styles from './Suggestions.module.css'

function getRandomIcebreakers(icebreakers: ImportedIcebreaker[], count: number): ImportedIcebreaker[] {
  const shuffled = [...icebreakers].sort(() => 0.5 - Math.random())
  return shuffled.slice(0, count)
}

export const Suggestions = ({onSuggestionClick}: {onSuggestionClick: (message: string) => void}) => {
  const suggestions = useMemo(() => {
    const randomSuggestions: ImportedIcebreaker[] = getRandomIcebreakers(data.functional, 6)
    return randomSuggestions
  }, [])

  return (
    <ul className={`${styles.suggestions} list-style-none`}>
      {suggestions.map((suggestion: ImportedIcebreaker) => (
        <li key={suggestion.id} className={styles.suggestionButton}>
          <SuggestionCard
            // eslint-disable-next-line @github-ui/github-monorepo/no-cast-as-safe-html-string
            titleHtml={suggestion.titleHtml as SafeHTMLString}
            icon={suggestion.icon}
            color={suggestion.color}
            onClick={() => {
              onSuggestionClick(suggestion.message)
            }}
          />
        </li>
      ))}
    </ul>
  )
}
